// import React from 'react';
import { graphql, useStaticQuery } from "gatsby";
// import { makeStyles } from '@material-ui/styles';
// import styles from './styles';
// import ReactHtmlParser from 'react-html-parser';
// import Link from '../../Link';

// const useStyles = makeStyles(theme => styles(theme));


export const CgbFeaturedProductsBlock = (props) => {
    // const classes = useStyles();

    // const data = useStaticQuery(graphql`
    //     query FeaturedProducts {
    //         wp {
    //             collections(where: {name: "Promo"}) {
    //                 nodes {
    //                     id
    //                     name
    //                     databaseId
    //                     products(first: 100) {
    //                         nodes {
    //                             title
    //                             uri
    //                             ProductData {
    //                                 backgroundColor
    //                                 backgroundImage
    //                                 imageUrl
    //                                 variants {
    //                                     price
    //                                     title
    //                                 }
    //                                 collections {
    //                                     sortOrder
    //                                     collectionDatabaseId
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // `);

    // let products = data.wp.collections && data.wp.collections.nodes[0] && data.wp.collections.nodes[0].products.nodes;

    // if (!products) return null;

    // let collectionID = data.wp.collections.nodes[0].databaseId;

    // let tempProducts = [];

    // products.map((product) => {
    //     // console.log(product);
    //     product.ProductData.collections.map((collection) => {
    //         // console.log(collection);
    //         // console.log(collectionID);
    //         if(collection.collectionDatabaseId === collectionID) {
    //             tempProducts.push({
    //                 title: product.title,
    //                 uri: product.uri,
    //                 backgroundColor: product.ProductData.backgroundColor,
    //                 imageUrl: product.ProductData.imageUrl,
    //                 variant: product.ProductData.variants[0].title,
    //                 price: product.ProductData.variants[0].price,
    //                 sortOrder: collection.sortOrder
    //             });
    //         }
    //     });
    // });

    // tempProducts.sort(function(a, b) {
    //     var keyA = new Date(a.sortOrder),
    //       keyB = new Date(b.sortOrder);
    //     // Compare the 2 dates
    //     if (keyA < keyB) return -1;
    //     if (keyA > keyB) return 1;
    //     return 0;
    // });

    // tempProducts = tempProducts.slice(0,3);

    // console.log(tempProducts);

    // return <div className={`featured-products ${props.attributes.className ? props.attributes.className : ''} ${classes.featuredProducts} ${classes.featuredProductsTheme}`}>
    //     <h2>What's in the shop</h2>
    //     <div className="product-listing">
    //         {tempProducts.map((product, index) => {
    //             return <Link
    //                 key={index}
    //                 to={product.uri}
    //                 className="product" 
    //                 style={ { backgroundColor: product.backgroundColor } }
    //             >
    //                 <span className="product-title">{product.title}</span>
    //                 <span className="button">
    //                     <span>Discover</span> More
    //                 </span>
    //                 <img src={product.imageUrl} alt="" />
    //             </Link>
    //         })}
    //     </div>
    //     <div className="shop-cat-links">
    //         <Link className="bottled-beers" to="/shop/collection/bottle-beers/">Bottled Beer</Link>
    //         <Link className="trooper" to="/shop/collection/trooper-store/">Trooper Store</Link>
    //         <Link className="gifts" to="/shop/collection/gifts-glasses/">Gifts & Glasses</Link>
    //         <Link to="/shop/" className="button">View All</Link>
    //     </div>
    // </div>

    return null;
};

export const CgbFeaturedProductsBlockFragment = graphql`
  fragment CgbFeaturedProductsBlock on WpBlock {
    ... on WpCgbFeaturedProductsBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFeaturedProductsBlockPreview = `
    ... on CgbFeaturedProductsBlock {
        name
        attributes {
            className
        }
    }
`;
